import { APPLICANTS_FILTER_PARAM } from '../../../../RentalPortalApplicant'

export const APPLICANTS_FILTER_PARAM_LIST = Object.values(
  APPLICANTS_FILTER_PARAM
)

export const APPLICANTS_FILTER_TOGGLE_VALUE = 'true'
